export default __webpack_public_path__ + "f7b4565a33b5a9cb88b54f1d7e790675.png";